export const LOCATE_USER_START = 'LOCATE_USER_START';
export const LOCATE_USER_SUCCESS = 'LOCATE_USER_SUCCESS';
export const LOCATE_USER_ERROR = 'LOCATE_USER_ERROR';
export const CLEAR_FOUND_USER = 'CLEAR_FOUND_USER';
